<template>
  <div class="set-option-item">
    <a-form-item class="item-move-icon">
      <i
        class="icon iconfont iconicon-test72"
      />
    </a-form-item>
    <a-form-item>
      <a-input
        v-decorator="decorator"
        :disabled="!!item.issystem"
        :placeholder="enterPlaceholder"
        @change="changeVal"
      />
    </a-form-item>
    <a-form-item v-if="itemData.fieldtype === 'radioinfo_type' || (itemData.fieldtype === 'radioinfo_followup')">
      <a-checkbox
        :default-checked="!!item.isend"
        @change="checkboxChange"
      >
        {{ $t('message["511"]') }}
      </a-checkbox>
    </a-form-item>
    <a-form-item
      v-if="itemData.fieldtype === 'select'"
      class="mr0"
    >
      <a-checkbox
        class="radio-item-check"
        :checked="!!item.isdefault"
        @change="radioChange"
      >
        <!-- {{ $t('message["511"]') }} -->
        {{ isDefaultTxt }}
      </a-checkbox>
    </a-form-item>
    <a-form-item class="mr0">
      <i
        v-if="!item.issystem"
        class="icon iconfont iconicon-test8"
        @click="delDefine(item,index)"
      />
    </a-form-item>
  </div>
</template>
<script>
export default {
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      decorator: [
        `input_${this.item.id || this.item._id}`,
        {
          rules: [{ required: true, message: this.$t('message["67"]') }, { validator: this.isNameRe }],
          initialValue: this.item.name
        }
      ]
    }
  },
  computed: {
    enterPlaceholder () {
      return this.$t('message["751"]')
    },
    isDefaultTxt () {
      const { isdefault = 0 } = this.item
      return isdefault ? this.$t('message[1780]') : this.$t('message[1779]')
    }
  },
  inject: ['diaform'],
  methods: {
    delDefine (item, index) {
      // const { form } = this
      // const inputDatas = form.getFieldValue('name')
      // inputDatas.splice(index, 1)
      // form.setFieldsValue({
      //   name: inputDatas
      // })
      this.itemData.options.splice(index, 1)
    },
    changeVal (e) {
      const val = (e.target.value).trim()
      this.item.name = val
      this.$nextTick(() => {
        this.diaform.form.setFieldsValue({
          [`input_${this.item.id || this.item._id}`]: val
        })
        // this.diaform.form.validateFields([`input_${this.item.id || this.item._id}`])
        this.diaform.form.validateFields({ force: true }, (errors, values) => {})
      })
    },
    checkboxChange (e) {
      if (e.target.checked) {
        this.item.isend = 1
      } else {
        this.item.isend = 0
      }
    },
    isNameRe (rule, value, callback) {
      const arr = this.itemData.options
      const len = arr.filter((item, index) => item.name === value).length
      if (len > 1) {
        callback(new Error(this.$t('message["69"]')))
      } else {
        callback()
      }
    },
    radioChange (e) {
      if (e.target.checked) {
        this.itemData.options.forEach(item => {
          this.$set(item, 'isdefault', 0)
        })
        this.item.isdefault = 1
      } else {
        this.item.isdefault = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .set-option-item::v-deep {
    height: 36px;
    padding: 8px 8px 4px 32px;
    line-height: 36px;
    box-sizing: content-box;
    position: relative;
     .radio-item-check {
      .ant-checkbox-inner{
        border-radius: 50%;
      }
      .ant-checkbox-input{
        border-radius: 50%;
      }
    }
    .iconicon-test72 {
      font-size: 16px;
      cursor: move;
      color: #ccc;
      display: none;
    }
    .item-move-icon {
      position: absolute;
      left: 8px;
    }
    .iconicon-test8 {
      color: #ccc;
      display: none;
      cursor: pointer;
    }

    .mr0 {
      margin-right: 0 !important;
    }
  }
  .set-option-item:hover {
    background: #f4f7f9;
    .iconicon-test72, .iconicon-test8 {
      display: inline-block;
    }
  }
</style>
